import { useEffect, useRef, useCallback, useState } from "react";
import { BASE_PATH } from "../../utils/constants";

// Components
import CtaButton from "../CtaButton/CtaButton";

// import Zoom from "react-medium-image-zoom";
// import "react-medium-image-zoom/dist/styles.css";

import ReactImageMagnify from "react-image-magnify";

export const JumbotronCarousel = () => {
  const initCarousel = () => {
    const slideContainer = document.querySelector(
      ".jumbotron__slide-container"
    );
    const slides = Array.from(slideContainer.children);
    const carouselNav = document.querySelector(".jumbotron__carousel__nav");
    const carouselPages = Array.from(carouselNav.children);

    const updatePage = (currentPage, wantedPage) => {
      currentPage.classList.remove("current-page");
      wantedPage.classList.add("current-page");
    };

    carouselPages.forEach((carouselPage, index) => {
      carouselPage.addEventListener("click", (event) => {
        slides.forEach((slide) => slide.classList.remove("current-slide"));
        slides[index].classList.add("current-slide");

        const currentPage = document.querySelector(".current-page");
        updatePage(currentPage, carouselPage);
        // setTimeout(() => {
        //   setSuccess(false);
        // }, 2000);
      });
    });
  };

  useEffect(() => {
    initCarousel();
  });

  return (
    <section className="jumbotron">
      <div className="jumbotron__container">
        <div className="jumbotron__carousel">
          <div className="jumbotron__slide-container">
            <div className="jumbotron__slide current-slide">
              <div className="jumbotron__slide__content">
                <h2 className="jumbotron__slide__title">
                  Descubre los últimos relojes de esta temporada
                </h2>
                <CtaButton
                  text="Descubre"
                  align="left"
                  extraContainerClasses="jumbotron__slide__cta-container"
                />
              </div>
            </div>
            <div className="jumbotron__slide">
              <div className="jumbotron__slide__content">
                <h2 className="jumbotron__slide__title">
                  Descubre los últimos relojes de esta temporada
                </h2>
                <CtaButton
                  text="Descubre"
                  align="left"
                  extraContainerClasses="jumbotron__slide__cta-container"
                />
              </div>
            </div>
            <div className="jumbotron__slide">
              <div className="jumbotron__slide__content">
                <h2 className="jumbotron__slide__title">
                  Descubre los últimos relojes de esta temporada
                </h2>
                <CtaButton
                  text="Descubre"
                  align="left"
                  extraContainerClasses="jumbotron__slide__cta-container"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="jumbotron__carousel__nav">
          <button className="jumbotron__carousel__pageButton current-page"></button>
          <button className="jumbotron__carousel__pageButton"></button>
          <button className="jumbotron__carousel__pageButton"></button>
        </div>
      </div>
    </section>
  );
};

export const ProductCarousel = ({ productName, productImages = [], product }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const carouselRef = useRef(null);
  const slideContainerRef = useRef(null);

  // Debug logging
  console.log('ProductCarousel props:', { productName, productImages, product });

  // Memoized handlers to prevent unnecessary re-renders
  const goToSlide = useCallback(
    (index) => {
      if (index < 0 || index >= productImages.length) return;

      const slideContainer = slideContainerRef.current;
      if (!slideContainer) return;

      const slides = slideContainer.children;
      if (!slides[index]) return;

      const slideWidth = slides[0]?.getBoundingClientRect().width || 0;
      const offset = slideWidth * index + (index > 0 ? 20 * index : 0);

      slideContainer.style.transform = `translateX(-${offset}px)`;
      setCurrentIndex(index);
    },
    [productImages.length]
  );

  const goToPrevious = useCallback(() => {
    if (currentIndex > 0) {
      goToSlide(currentIndex - 1);
    }
  }, [currentIndex, goToSlide]);

  const goToNext = useCallback(() => {
    if (currentIndex < productImages.length - 1) {
      goToSlide(currentIndex + 1);
    }
  }, [currentIndex, productImages.length, goToSlide]);

  // Keyboard navigation
  const handleKeyDown = useCallback(
    (e) => {
      switch (e.key) {
        case "ArrowLeft":
          e.preventDefault();
          goToPrevious();
          break;
        case "ArrowRight":
          e.preventDefault();
          goToNext();
          break;
        case "Home":
          e.preventDefault();
          goToSlide(0);
          break;
        case "End":
          e.preventDefault();
          goToSlide(productImages.length - 1);
          break;
      }
    },
    [goToPrevious, goToNext, goToSlide, productImages.length]
  );

  // Initialize carousel layout
  const initializeLayout = useCallback(() => {
    const slideContainer = slideContainerRef.current;
    if (!slideContainer || !slideContainer.children.length) return;

    const slides = Array.from(slideContainer.children);
    const slideWidth = slides[0]?.getBoundingClientRect().width || 0;

    // Set up slide positions
    slides.forEach((slide, index) => {
      const offset = index === 0 ? 0 : slideWidth * index + 20 * index;
      slide.style.left = `${offset}px`;
    });

    // Reset to first slide
    slideContainer.style.transform = "translateX(0px)";
    setCurrentIndex(0);
  }, []);

  // Setup effect with proper cleanup
  useEffect(() => {
    if (!productImages.length) return;

    // Small delay to ensure DOM is ready
    const timer = setTimeout(initializeLayout, 50);

    return () => clearTimeout(timer);
  }, [productImages, initializeLayout]);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      initializeLayout();
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [initializeLayout]);

  // Early return for empty images
  if (!productImages.length) {
    return (
      <section className="product-carousel">
        <div className="product-carousel__container">
          <p>No images available</p>
        </div>
      </section>
    );
  }

  const showPrevButton = currentIndex > 0;
  const showNextButton = currentIndex < productImages.length - 1;

  return (
    <section
      className="product-carousel"
      ref={carouselRef}
      onKeyDown={handleKeyDown}
      tabIndex={0}
      role="region"
      aria-label={`${productName} image carousel`}
    >
      <div className="product-carousel__container">
        {/* Discount Badge */}
        {product?.descuentoInfo && (
          <div className="product-carousel__discount-badge">
            -{product.descuentoInfo.porcentajeDescuento}%
          </div>
        )}
        <div className="product-carousel__carousel">
          <button
            className={`product-carousel__carousel__button product-carousel__carousel__button--left ${!showPrevButton ? "v-hidden" : ""
              }`}
            onClick={goToPrevious}
            disabled={!showPrevButton}
            aria-label="Previous image"
            type="button"
          >
            <i
              className="product-carousel__carousel__button__icon fal fa-arrow-left"
              aria-hidden="true"
            ></i>
          </button>

          <div
            className="product-carousel__slide-container"
            ref={slideContainerRef}
            role="img"
            aria-live="polite"
            aria-label={`Image ${currentIndex + 1} of ${productImages.length}`}
          >
            {productImages.map((productImage, index) => (
              <div
                key={`slide-${index}`}
                className="product-carousel__slide"
                aria-hidden={index !== currentIndex}
              >
                <ReactImageMagnify
                  {...{
                    enlargedImageContainerClassName:
                      "product-carousel__slide__magnify",
                    smallImage: {
                      alt: `${productName} - Image ${index + 1}`,
                      isFluidWidth: true,
                      src: productImage?.url || "",
                      onError: (e) => {
                        console.warn(
                          `Failed to load image: ${productImage?.url}`
                        );
                        e.target.style.display = "none";
                      },
                    },
                    largeImage: {
                      src: productImage?.url || "",
                      width: 800,
                      height: 900,
                    },
                  }}
                />
              </div>
            ))}
          </div>

          <button
            className={`product-carousel__carousel__button product-carousel__carousel__button--right ${!showNextButton ? "v-hidden" : ""
              }`}
            onClick={goToNext}
            disabled={!showNextButton}
            aria-label="Next image"
            type="button"
          >
            <i
              className="product-carousel__carousel__button__icon fal fa-arrow-right"
              aria-hidden="true"
            ></i>
          </button>
        </div>

        <div
          className="product-carousel__carousel__nav"
          role="tablist"
          aria-label="Image navigation"
        >
          {productImages.map((_, index) => (
            <button
              key={`nav-${index}`}
              className={`product-carousel__carousel__pageButton ${index === currentIndex ? "current-page" : ""
                }`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to image ${index + 1}`}
              aria-selected={index === currentIndex}
              role="tab"
              type="button"
            />
          ))}
        </div>
      </div>
    </section>
  );
};
